import { render, staticRenderFns } from "./playerManage.vue?vue&type=template&id=119f70e3&scoped=true&"
import script from "./playerManage.vue?vue&type=script&lang=ts&"
export * from "./playerManage.vue?vue&type=script&lang=ts&"
import style0 from "./playerManage.vue?vue&type=style&index=0&id=119f70e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119f70e3",
  null
  
)

export default component.exports